import React, { useState, useEffect } from "react";
import { Box, TextField, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import { post, put } from "../../../../../utils/api";
import { companyId } from "../../../../../utils/companyId";
import { textError } from "../../../../../utils/validationMessage";
import EditDialog from "../../../../../Components/Common/EditDialog";

function AddVendor(props) {
  const [alreadyVendor, setAlreadyVendor] = useState(false);
  const [errors, setErrors] = useState({});
  const initialState = {
    company: companyId,
    VendorLegalFullName: "",
  };
  const [editDialog, setEditDialog] = useState(false);
  const [formData2, setFormData2] = useState([]);

  const handleExitAgree = () => {
    console.log("_idddddd", props.selectedVendor?._id);
    setFromValue(
      props.selectedVendor?._id === undefined
        ? initialState
        : props.selectedVendor
    );
    setFormData2(
      props.selectedVendor?._id === undefined
        ? initialState
        : props.selectedVendor
    );
    setErrors({});
    props.setAddVendor(false);
    setEditDialog(false);
  };

  const handleClose = () => {
    const isFormDataUnchanged = Object.keys(fromValue).every(
      (key) => fromValue[key] === formData2[key]
    );

    if (isFormDataUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true);
    }
  };

  const [fromValue, setFromValue] = useState(initialState);
  console.log("propsEquipment", props);

  useEffect(() => {
    setFromValue({
      company: companyId,
      VendorLegalFullName: props.selectedVendor?.VendorLegalFullName ?? "",
    });
    setFormData2({
      company: companyId,
      VendorLegalFullName: props.selectedVendor?.VendorLegalFullName ?? "",
    });
    setAlreadyVendor(props.selectedVendor === null ? false : true);
  }, [props.selectedVendor]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("nam===e", name, value);
    setFromValue({
      ...fromValue,
      [name]: value,
    });
    setErrors({ ...errors, [name]: "" });
  };
  const validateForm = () => {
    const newErrors = {};

    const { VendorLegalFullName } = fromValue;

    if (!VendorLegalFullName || VendorLegalFullName.trim() === "") {
      newErrors.VendorLegalFullName = textError;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const Save = async () => {
    if (!validateForm()) {
      return;
    }
    let method = alreadyVendor ? put : post;
    let url = alreadyVendor
      ? `/master/Heat/updateVendor?Id=${props.selectedVendor?._id}`
      : `/master/Heat/creatVendor`;

    await method(url, fromValue)
      .then((res) => {
        console.log(res, res.data.data);
        props.setAddVendor(false);
        props.fetchSteamVendor();
        handleExitAgree();
        props.setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        setFromValue((pre) => {
          return {
            ...pre,
          };
        });
      })
      .catch((err) => {
        console.log(err);
        if (err?.response?.data?.message) {
          // If there is a message in the error response, use it
          setErrors({
            ...errors,
            VendorLegalFullName: "Vendor already exists",
          });
        }
      });
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.4rem",
        maxWidth: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={() => {
            handleClose();
          }}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          padding: "24px",
          backgroundColor: "#fff",
          height: "100%",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",

            mb: 2,
          }}
        >
          {props.selectedVendor?._id === undefined
            ? " Add Heating and Cooling Vendor"
            : "Edit Heating and Cooling Vendor"}
        </Typography>

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Vendor Legal Full Name
        </Typography>

        <CustomTextField
          //   select
          variant="outlined"
          value={fromValue.VendorLegalFullName}
          onChange={handleChange}
          fullWidth
          name="VendorLegalFullName"
          placeholder="Vendor Legal Full Name"
          error={!!errors.VendorLegalFullName} // Show error styling if there's an error
          InputLabelProps={{
            style: {
              color: errors.VendorLegalFullName ? "#D34040" : undefined,
            },
          }}
        ></CustomTextField>
        {errors.VendorLegalFullName && (
          <Typography variant="body2" color="#D34040">
            {errors.VendorLegalFullName}
          </Typography>
        )}

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            minHeight: "70%", // Ensures the box takes up the full height of the page
          }}
        >
          {/* Other content goes here */}

          <Box
            sx={{
              marginTop: "auto", // Pushes the button to the bottom
              // textAlign: 'center', // Center the button horizontally
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#0a3f73",
                textTransform: "none",
                marginTop: "10%", // Can adjust this to control spacing
              }}
              onClick={Save}
            >
              Submit
            </Button>
          </Box>
        </Box>

        {/* </Box> */}
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            // This targets the paper component within the Drawer
            backgroundColor: "transparent", // Make paper transparent
            boxShadow: "none", // Optional: Remove any shadow
          },
        }}
        anchor="right"
        open={props.addVendor}
        onClose={() => {
          handleClose();
        }}
      >
        {list()}
      </Drawer>
    </div>
  );
}

export default AddVendor;

//// custom textfield

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px", // Adjust height as needed
  },
  "& .MuiSelect-select": {
    height: "56px", // Adjust height as needed
    display: "flex",
    alignItems: "center",
  },
}));
